import { createContext, useEffect, useContext } from "react";
import { StoreApi, useStore } from "zustand";

export interface SelectionStore {
  selected: Set<string>;

  addToSelection: (id: string) => void;
  removeFromSelection: (id: string) => void;
  clearSelection: () => void;
}

export const SelectionContext = createContext<StoreApi<SelectionStore> | null>(null);

export const useClearSelectionOnNavigation = () => {
  const [selected, clear] = useSelection(store => [store.selected, store.clearSelection]);

  useEffect(() => {
    return () => {
      if (selected.size > 0) {
        console.log(
          `We might want to alert the user that they are about to navigate away from a page with ${selected.size} selected items.`
        );
      }

      clear();
    };
  });
};

export function useSelection<U>(selector: (store: SelectionStore) => U): U {
  const context = useContext(SelectionContext);
  if (!context) {
    throw new Error('useSelection must be used within a SelectionProvider');
  }
  return useStore(context, selector);
}

export function useIsSelected(id: string) {
  return useSelection(state => state.selected.has(id));
}
